import {readGridDensity} from '../shared/components/grid-density-control/grid-density-control.component';
import {AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, from, Subscription, Subject} from "rxjs";
import { debounceTime, delay, map, filter } from 'rxjs/operators';

 import {StreamsService}  from "../shared/services/streams.service";
import {StreamProject} from "../shared/interfaces";
 import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {SocketStreamsOverview, socketEvents} from '../shared/services/sockets';
import { NbDialogService,NbGlobalPosition, NbToastrService } from '@nebular/theme';
import { NbMenuService } from '@nebular/theme';
  import { GoogleAnalyticsService } from '../@core/utils/analytics.service';

@Component({
  selector: 'app-overview-page', 
  templateUrl: './overview-page.component.html',
  styleUrls: ['./overview-page.component.scss'],
  
})
export class OverviewPageComponent implements OnInit, OnDestroy, AfterViewInit{

  // Cards per row, as a ceiling - the grid drops a column by itself rather than
  // squeezing cards below a readable width.
  colsKey: string = 'livestream:streams:cols'
  cols: number = readGridDensity(this.colsKey)


  isRoot: boolean = true
  @ViewChild('deleteModal') deleteModal: any;
   
  pending = false;
  createSub$: Subscription; 
  removeSub$: Subscription;
   fetchLoading: boolean = true;
  streams$: Subscription;
  timeNow: any = moment().unix();
  thumbsTimer: any = null
  showControls: boolean = false
 createMenuOpened: boolean = false 
  streamToDelete: StreamProject = null
  removeLoading:boolean = false
  watchersChanged$: Subject<any> = new Subject();
 watchersChangedFn: any
    menuSub$:any;
 
  streams: StreamProject[] 

  constructor(  private streamsService: StreamsService,  
    private socket: SocketStreamsOverview,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService,
public gAnalytics: GoogleAnalyticsService,
private nbMenuService: NbMenuService
    ){
    //  this.socket.removeAllListeners()
   //   this.socket.disconnect()
  }
  
  
  @HostListener('document:click', ['$event'])
  clickout(event) {
  
    
    if(!event.target.closest('.topPanel')) {
      this.createMenuOpened = false;
    }
  }
   

  ngOnInit() { 
  this.streams$ = this.streamsService.fetch().subscribe((streams: StreamProject[])=>{

    let ids = []
      this.streams = streams.map(s =>{
        s.isRunning = false
        ids.push(s.publicIdentity)
        return s
      })


      this.socket.on('connect', ()=>{
        this.socket.emit('onJoin', {
          ids
        })

 
 
        this.fetchLoading = false 
	 
      })

      this.socket.on(socketEvents.overviewInitialRunings, this.overviewInitialRunings.bind(this))
      this.socket.on(socketEvents.overviewChangeRunings, this.overviewChangeRunings.bind(this))


      //initialWatchers
      this.socket.on('changeSignal', this.overviewChangeSignal.bind(this))
      this.socket.on('initialWatchers', this.onInitialWatchers.bind(this))
      this.socket.on('watchersChanged', this.onWatchersChanged.bind(this))

      
      this.socket.connect()


 		if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }
		this.menuSub$ =	  this.nbMenuService.onItemClick()
		      .pipe(
 			filter(({ tag }) => tag === 'stream-menu'),
			 map(({ item }) => item)
		      )
		      .subscribe( (item : any) => {this.onMenuClick(item.cmd, item.item);  }); 
      //
     },()=>{
      this.fetchLoading = false
      this.toastrService.show(``,'Сталася помилка завантаження',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-end'
      })
    })   


	this.watchersChangedFn = this.watchersChanged.bind(this)

	 this.watchersChanged$
      .pipe(debounceTime(1000))

      .subscribe(this.watchersChangedFn);
  }


   onMenuClick(cmd, stream){ 
	if(cmd === 'remove') { this.streamToDelete = stream; this.openRemoveModal();   return;}



  }


  openRemoveModal() {
    
    this.dialogService.open(this.deleteModal,{hasScroll: true} )
  
    
  }
  
  



  removeSelectedStream(ref){
    ref.close()
    this.removeStream(this.streamToDelete)

  }


  removeStream(stream: StreamProject){
    

      if(this.removeSub$){
        this.removeSub$.unsubscribe()
      }

	this.removeLoading = true	

    this.removeSub$ = this.streamsService.delete(stream._id).subscribe(()=>{
      this.streamToDelete = null

     this.toastrService.show(`Трансляція "${stream.title}" видалена`,'Видалення трансляції',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-end'
    })
      this.streams = this.streams.filter(s => s._id !== stream._id)
    },()=>{
	 this.toastrService.show(`Сталася помилка при видаленні`,'Видалення трансляції',{
      status: 'danger',
	position: <NbGlobalPosition>'bottom-end'
    })
	this.removeLoading = false  
	},()=>{
	

	this.removeLoading = false  
	

	})
  }

  startThumbsUpdateTimer(){
    
    if(this.thumbsTimer === null){
        this.thumbsTimer = setInterval(()=>{
          this.timeNow =  moment().unix();
      },10000)
    }
  }


  stopThumbsUpdateTimer(){
    if(this.thumbsTimer ){
      clearInterval(this.timeNow)
      this.timeNow = null
    }
  }
  overviewInitialRunings(streams){
    
    var c = 0
    for(let stream of streams) {

        const candidate = this.streams.find(s=> ""+s._id == stream.id)
          if(candidate) {
          //  console.log(candidate)
          if( stream.isRunning){
            c++
          }
            
            candidate.isRunning = stream.isRunning
            candidate.hasSignal = true
 
          }

    }

    if(c>0){
      this.startThumbsUpdateTimer()
    }
    
  }


	watchersChanged(data){


	    let stream = this.streams.find((s)=>data.publicIdentity === s.publicIdentity)
	   // console.log(data, stream)

	      if(stream){
		stream.watchersCount = data?.watchers ? data.watchers : 0
	      }
  	}

  onWatchersChanged(data){

	this.watchersChanged$.next(data)
/*

    let stream = this.streams.find((s)=>data.publicIdentity === s.publicIdentity)
   // console.log(data, stream)

      if(stream){
        stream.watchersCount = data?.watchers ? data.watchers : 0
      }   
*/  
  }
 

  onInitialWatchers(data){
    this.streams = <StreamProject[]>this.streams.map((s)=>{
 
      let dt = data.find((d)=> {return d.publicIdentity === s.publicIdentity});
      s.watchersCount = dt?.watchers ? dt.watchers : 0

      return s
    }) 
  }

  
  overviewChangeSignal(data){
   
    
    for(let stream of this.streams) {

      if(""+stream._id === data.id){
        stream.hasSignal = data.hasSignal

      }

      
    } 
    
} 

  
  overviewChangeRunings(data){
  
      var c = 0
      for(let stream of this.streams) {

        if(""+stream._id === data.id){
          stream.isRunning = data.isRunning
 
        }

        if(stream.isRunning){
          c++
        }
      }

      if(c>0){
        this.startThumbsUpdateTimer()
      }else{
        this.stopThumbsUpdateTimer()
      }
      
  }



  

 
  createStream(streamType){

    this.createSub$ = this.streamsService.create(streamType).subscribe((stream: StreamProject)=>{


      this.toastrService.show(`Трансляція "${stream.title}" створена`,'Створення трансляції',{
        status: 'success',
	position: <NbGlobalPosition>'bottom-end'
      })

        stream.isRunning = false
        this.streams.unshift(stream)

	 this.gAnalytics.trackEvent('Add_stream') 
    },()=>{
      
      this.toastrService.show(``,'Сталася помилка',{
        status: 'danger',
        position: <NbGlobalPosition>'bottom-end'
      })
    })

  }


  ngAfterViewInit() {
    }
 
   ngOnDestroy() {
//     this.modal.destroy()
     if(this.createSub$){
       this.createSub$.unsubscribe()
     }

     if(this.streams$){
      this.streams$.unsubscribe()
    }

    if(this.removeSub$){
      this.removeSub$.unsubscribe()
    }
 
 if(this.menuSub$){
	      this.menuSub$.unsubscribe()
	   	 }
	if(this.watchersChangedFn)
	this.watchersChanged$.unsubscribe()



  // this.socket.removeAllListeners()
   this.socket.disconnect()
	this.socket.removeAllListeners(socketEvents.overviewInitialRunings)
	this.socket.removeAllListeners(socketEvents.overviewChangeRunings)
	this.socket.removeAllListeners('changeSignal')
	this.socket.removeAllListeners('initialWatchers')
	this.socket.removeAllListeners('watchersChanged')
	this.socket.removeAllListeners('connect') /**/

 
   }
 
  
}
